import React, { useState } from "react";
import "./salereportpos.css";

export const SaleReportPos = React.forwardRef((props, ref) => {
  const { rows, totalAmount, dateAquire, VAT, discount, invoiceNumber } = props;

  const [currentTime] = useState(new Date());
  const time = currentTime.toLocaleTimeString();

  return (
    <div ref={ref} className="pos-invoice">
      <div className="invoice-header">
        <div className="shop-name">MANAVIEA ATTIRE</div>
        <div className="shop-tagline">" UNVEIL YOUR ELEGANCE "</div>
        <div className="shop-address">
          Level-3, Block-C, Shop-32
          <br />
          Bashundara City, Panthapath, Dhaka-1215
          <br />
          Mobile: +8801319-931119
          <br />
          Mobile: +8801320-656271
          <br />
          <span className="vat-details">
            <span>
              VAT Registration No: <br /> 004125221-0203
            </span>
            <span>Mushak: 6.5</span>
          </span>
        </div>
      </div>

      <div className="invoice-title">BILLING INVOICE</div>

      <div className="invoice-meta">
        <div className="meta-row">
          <span>Invoice No:</span>
          <span>{invoiceNumber}</span>
        </div>
        <div className="meta-row">
          <span>Date:</span>
          <span>{dateAquire}</span>
        </div>
        <div className="meta-row">
          <span>Time:</span>
          <span>{time}</span>
        </div>
      </div>

      <div className="items-table">
        <div className="table-header">
          <div className="col-serial">#</div>
          <div className="col-desc">Description</div>
          <div className="col-qty">Qty</div>
          <div className="col-total">Total</div>
        </div>

        <div className="table-body">
          {rows &&
            rows.map((item, index) => (
              <div className="table-row" key={index}>
                <div className="col-serial">{index + 1}</div>
                <div className="col-desc">
                  {item.ProductTrace ? item.ProductTrace.name : ""}{" "}
                  {item.ProductTrace ? item.ProductTrace.product_code : ""}
                </div>
                <div className="col-qty">
                  {item.quantity_no} {item.Unit ? item.Unit.unit : ""}
                </div>
                <div className="col-total">
                  {(
                    parseFloat(item.sale_price || 0) *
                    parseFloat(item.quantity_no || 0)
                  ).toFixed(1)}
                </div>
              </div>
            ))}
        </div>

        <div className="table-footer">
          {VAT > 0 && (
            <div className="summary-row">
              <div className="summary-label">VAT</div>
              <div className="summary-value">{VAT}</div>
            </div>
          )}
          {discount > 0 && (
            <div className="summary-row">
              <div className="summary-label">Discount</div>
              <div className="summary-value">{discount}%</div>
            </div>
          )}
          <div className="summary-row total-row">
            <div className="summary-label">Net Total</div>
            <div className="summary-value">{totalAmount}</div>
          </div>
        </div>
      </div>

      <div className="invoice-footer">
        <div className="thank-you">Thank you for shopping with us!</div>
        <div className="terms">
          <div>Terms & Conditions: No Cash Refund</div>
          <div>Powered by MerinaSoft</div>
          <div>173 Arambag, Motijheel</div>
        </div>
      </div>
    </div>
  );
});
